import format from '../utils/format';

export default function radioSelected() {
	return {
		validate(input) {
			const radios = input.elements;
			const opts = input.options;
			let selectedValue;
			radios.forEach((radio) => {
				if (radio.checked) {
					selectedValue = radio.value;
				}
			})
			return {
				message: format(opts.message),
				valid: selectedValue
			};
		}
	}
};
